module.exports = __webpack_public_path__ + "img/services-placeholder-big.bd59e2b2.jpg";